<template>
  <van-dropdown-menu>
    <van-dropdown-item
      v-model="currentLanguage"
      :options="languageOptions"
      @change="handleLanguageChange"
    />
  </van-dropdown-menu>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { showSuccessToast, Locale } from 'vant'
import { getUserLang, setUserLang } from '@/storage/user'
import { useI18n } from 'vue-i18n'
// import customZhCN from '@/locales/zh-CN'
// import customEnUS from '@/locales/en-US'
import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'
interface LanguageOption {
  text: string
  value: string
}

const languageOptions: LanguageOption[] = [
  { text: '中文', value: 'zh-CN' },
  { text: 'English', value: 'en-US' }
]
const { locale } = useI18n() // 新增：获取 vue-i18n 的 locale
const currentLanguage = ref(getUserLang())

onMounted(() => {
  currentLanguage.value = getUserLang()
})

const handleLanguageChange = (value: string) => {
  setUserLang(value)
  showSuccessToast(value === 'zh-CN' ? '语言已切换为中文' : 'Language switched to English')
  document.documentElement.lang = value
  // 更新 vue-i18n 语言
  locale.value = value
  if (value === 'en-US') {
    Locale.use('en-US', enUS)
  } else if (value === 'zh-CN') {
    Locale.use('zh-CN', zhCN)
  }
}
</script>

<style lang="scss" scoped>
.van-dropdown-menu {
  background: transparent;
  height: auto;

  :deep(.van-dropdown-menu__bar) {
    background: transparent;
    box-shadow: none;
    height: auto;
  }

  :deep(.van-dropdown-menu__title) {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.95rem;
    padding: 0 8px;

    &::after {
      border-color: rgba(255, 255, 255, 0.6);
    }

    &:active {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  :deep(.van-dropdown-item__option) {
    text-align: center;
  }
}

@media (max-width: 768px) {
  .van-dropdown-menu {
    :deep(.van-dropdown-menu__title) {
      font-size: 0.85rem;
    }
  }
}
</style>
